import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { MatListModule } from '@angular/material/list';
import { Roles } from '../../enums/roles.enum';
import { UserService } from '../../services/user/user.service';
import { MenuItemComponent } from '../menu-item/menu-item.component';

export interface IMenuItem {
    disabled?: boolean;
    icon?: string;
    label: string;
    route?: string;
    subItems?: IMenuItem[];
}

@Component({
    selector: 'pims-side-menu',
    imports: [MatListModule, MenuItemComponent],
    templateUrl: './side-menu.component.html',
    styleUrl: './side-menu.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideMenuComponent implements OnInit {
    private readonly userService = inject(UserService);
    private readonly breakpointObserver = inject(BreakpointObserver);
    private readonly destroyRef = inject(DestroyRef);

    readonly collapsed = signal(false);
    private readonly activeRole = toSignal(this.userService.activeRole$);

    readonly menuItems = computed(() => this.getMenu(this.activeRole()));

    ngOnInit(): void {
        this.breakpointObserver
            .observe(['(min-width: 900px)'])
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((state: BreakpointState) => {
                if (state.matches) {
                    this.collapsed.set(false);
                } else {
                    this.collapsed.set(true);
                }
            });
    }

    getMenu(role: string | null | undefined): IMenuItem[] {
        const commonMenu: IMenuItem[] = [
            {
                label: 'dashboard',
                icon: 'images/dashboard.svg',
                route: '/web/dashboard',
            },
        ];

        let roleMenu: IMenuItem[] = [];

        switch (role) {
            case Roles.DISTRICT_PE_MANAGER:
                roleMenu = [
                    {
                        label: 'pims',
                        icon: 'images/pims.svg',
                        route: '/web/pims',
                    },
                ];
                break;

            case Roles.NATIONAL_MANAGER_MARKETING:
                roleMenu = [
                    {
                        label: 'productCategories',
                        icon: 'images/tag.svg',
                        route: '/web/product-categories',
                    },
                ];
                break;

            case Roles.BLOCK_MANAGER_MARKETING:
            case Roles.DISTRICT_MANAGER_MARKETING:
            case Roles.STATE_MANAGER_MARKETING:
                roleMenu = [
                    {
                        label: 'productQueue',
                        icon: 'images/tag.svg',
                        route: '/web/product-queue',
                    },
                ];
                break;
        }

        return role ? [...commonMenu, ...roleMenu] : [];
    }
}
